"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var colors_1 = require("../colors");

var themes_1 = require("../themes");

exports.SignIn = function (props) {
  var _a;

  return react_1.default.createElement("svg", __assign({}, props, {
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48
  }), react_1.default.createElement("defs", null, react_1.default.createElement("path", {
    fill: (_a = colors_1.getColor(props), _a !== null && _a !== void 0 ? _a : themes_1.defaultTheme.colors.default.onColor),
    id: "i-661",
    d: "M48,0v48H13V27h2v19h31V2H15v19h-2V0H48z M20.293,32.293l1.414,1.414L31.414,24l-9.708-9.707l-1.414,1.414L27.586,23H0v2 h27.586L20.293,32.293z"
  })), react_1.default.createElement("use", {
    x: 0,
    y: 0,
    xlinkHref: "#i-661"
  }));
};